<template>
    <v-app id="app">
        <v-navigation-drawer v-if="connected"
            class="pad-navigation"
            app temporary fixed right
            disable-resize-watcher
            v-model="drawerRight">

            <pad-menu-variant v-model="drawerRight" />

            <v-spacer />
            <pad-footer />
        </v-navigation-drawer>
        <pad-top-toolbar v-if="connected" v-model="drawerRight" />
        <v-content>
            <v-alert color="error" :value="!storageAvailable" dismissible>
                La configuration de votre navigateur ne permet pas d'enregistrer
                les préférences. Certains atouts (reconnexion automatique) ne
                sont dès lors pas fonctionnels. Merci de votre compréhension.
            </v-alert>

            <pad-message />
            <pad-message-popup />
            <pad-login-popup />
            <pad-errata-popup />
            <router-view/>

        </v-content>
    </v-app>
</template>

<script>
import PadTopToolbar from '@/components/PadTopToolbar'
import PadFooter from '@/components/PadFooter'
import PadMenuVariant from '@/components/PadMenuVariant'
import PadMessage from '@/components/PadMessage'
import PadMessagePopup from '@/components/PadMessagePopup'
import PadLoginPopup from '@/components/PadLoginPopup'
import PadErrataPopup from '@/components/PadErrataPopup'
import Vue from 'vue'

export default {
    name: 'pad',
    components: { PadMenuVariant, PadMessage, PadMessagePopup, PadLoginPopup, PadErrataPopup, PadTopToolbar, PadFooter },
    data: () => ({
        drawerRight: false
    }),
    computed: {
        connected() {
            return this.$store.getters['auth/connected']
        },
        storageAvailable() {
            return Vue.prototype.$storage.available()
        }
    },
    created() {
        const errInterceptor = (err) => {
            const res = (err.response && err.response.data) || {}
            const msg = (res.error && res.error.message) || (err && err.message)
            const status = err.response && err.response.status
            if (status === 401 || status === 403) {
                if (this.$route.name !== 'login') {
                    this.$store.commit('auth/show')
                } else {
                    this.$store.commit('msg/show', {
                        message: "Vous n'avez pas les droits pour vous connecter",
                        type: 'error'
                    })
                }
            } else if (status !== 501) {
                this.$store.commit('msg/show', { message: msg, type: 'error' })
            }
            throw err
        }
        Vue.prototype.$api.interceptors.response.use(undefined, errInterceptor)
        Vue.prototype.$auth.interceptors.response.use(undefined, errInterceptor)
        Vue.prototype.$http.interceptors.response.use(undefined, errInterceptor)
    }
}
</script>

<style lang="stylus" scoped>
.pad-navigation
    display: flex !important;
    flex-direction: column !important;

</style>
